import React from "react";

export default function EmptyState({
  message = "No data available.",
  className = "",
  compact = false,
}) {
  return (
    <div
      className={[
        "new-empty-state",
        compact ? "is-compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <p>{message}</p>
    </div>
  );
}
